import React, { useState, useRef, useEffect } from "react";
import { Typography, Box, Button, Slide, Fade, useMediaQuery, useTheme, ToggleButton, ToggleButtonGroup } from '@mui/material';
import Navbar from "../components/Navbar";

function Infospratiques() {
  const mapRef = useRef(null);
  const [checked, setChecked] = useState(false);
  const [timePeriod, setTimePeriod] = useState('morning');
  const contentRef = useRef(null);
  const containerRef = useRef(null);
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  useEffect(() => {
    const handleScroll = () => {
      const contentPosition = contentRef.current.getBoundingClientRect().top;
      const screenHeight = window.innerHeight;

      if (contentPosition < screenHeight - 100) {
        setChecked(true);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleTimePeriodChange = (event, newTimePeriod) => {
    if (newTimePeriod !== null) {
      setTimePeriod(newTimePeriod);
    }
  };

  return (
    <Box>
      <Navbar />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
          overflowY: 'auto',
          backgroundColor: '#952f5a',
          color: '#ebe8e8',
          backgroundImage: `
            repeating-linear-gradient(to right,
              rgba(0, 0, 0, 0) 0%,
              rgba(0, 0, 0, 0) calc(50% - 1px),
              #9f3161 calc(50% - 1px), #9f3161 calc(50% + 1px),
              rgba(0, 0, 0, 0) calc(50% + 1px), rgba(0, 0, 0, 0) 100%
            )
          `,
          backgroundSize: 'calc(100% / 5) 100%'
        }}
      >
        <Box ref={containerRef} sx={{ padding: '3rem', textAlign: 'center' }}>
          <Slide direction="up" in={true} container={containerRef.current}>
            <Typography variant="h1" sx={{ fontSize: { xs: '4rem', lg: '8rem' }, fontWeight: 'bold' }}>INFOS</Typography>
          </Slide>
        </Box>
      </Box>
      <Box
        id="content2"
        ref={contentRef}
        sx={{
          height: { md: '100vh' },
          display: 'flex',
          flexDirection: {md:'row',sm:'column',xs:'column'},
          gap: '1rem',
          justifyContent: 'center',
          alignItems: 'center',
          padding: 2,
          overflowY: 'auto',
          backgroundColor: 'rgba(58, 29, 29, 0.1)',
          backgroundImage: `
            repeating-linear-gradient(to right,
              rgba(0, 0, 0, 0) 0%,
              rgba(0, 0, 0, 0) calc(50% - 1px),
              #FFFFFF calc(50% - 1px), #FFFFFF calc(50% + 1px),
              rgba(0, 0, 0, 0) calc(50% + 1px), rgba(0, 0, 0, 0) 100%
            )
          `,
          backgroundSize: 'calc(100% / 5) 100%'
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '3rem',
            justifyContent: 'center',
            width: { xs: '90%', sm: '30rem' },
            textAlign: isSmallScreen ? 'center' : 'left',
          }}
          ref={containerRef}
        >
          <Slide direction="left" in={checked} container={containerRef.current} timeout={1000}>
            <Box>
              <Typography variant="h2" component="div" sx={{ fontWeight: 'bold', display: { xs: 'none', md: 'block' } }}>
                INFOS PRATIQUES
              </Typography>
            </Box>
          </Slide>
          <Fade in={checked} container={containerRef.current} timeout={1200}>
            <Box>
              <Typography variant="body1" component="div" sx={{ fontWeight: 'bold', width: '90%' }}>
                La ROCS se tiendra le samedi 21 septembre sur le campus de CentraleSupélec à Gif sur Yvette. Les épreuves se dérouleront dans les installations sportives du campus (sauf pour le golf). Rendez-vous au Village ROCS avant 9h !
              </Typography>
              <Typography variant="body1" component="div" sx={{ marginTop: '1rem', fontWeight: 'bold' }}>
                Horaires des événements :
              </Typography>

              <ToggleButtonGroup
                value={timePeriod}
                exclusive
                onChange={handleTimePeriodChange}
                sx={{ my: '1rem' }}
              >
                <ToggleButton value="morning">Matin</ToggleButton>
                <ToggleButton value="afternoon">Après-midi</ToggleButton>
              </ToggleButtonGroup>

              <ul sx={{ fontWeight: 'bold' }}>
                {timePeriod === 'morning' && (
                  <>
                    <li>Handball : 9h15 à 12h en EDF</li>
                    <li>Cross : 10h à 12h</li>
                    <li>Volley : 9h15 à 12h au COUM</li>
                    <li>Escalade : 9h15 à 12h en POLY</li>
                    <li>Tennis de Table: 9h15 à 12h en POLY</li>
                    <li>Football: 9h15 à 12h en PDS</li>
                    <li>Rugby: 9h15 à 12h en PDS</li>
                    <li>Golf: 9h à 11h30 au Golf de Saint-Aubin</li>
                    <li>Mini Golf: 9h à 11h30 au Golf de Saint-Aubin</li>
                  </>
                )}
                {timePeriod === 'afternoon' && (
                  <>
                    <li>Basket: 14h à 17h au COUM</li>
                    <li>Molky: 14h à 17h en REZ 2</li>
                    <li>Tennis de Table: 14h à 17h en POLY</li>
                    <li>Pétanque: 14h à 17h en Rez 2</li>
                    <li>Tennis: 14h à 17h en Rez 2</li>
                    <li>Beach Volley: 14h à 17h au Rez 1</li>
                    <li>Escalade: 14h à 17h en POLY</li>
                    <li>Badminton: 14h à 17h en EDF</li>
                    <li>Spikeball: 14h à 17h en REZ 2</li>
                    <li>Hockey: 14h à 17h en PDS</li>
                  </>
                )}
              </ul>

              <Typography variant="body1" component="div" sx={{ marginTop: '2rem', fontWeight: 'bold' }}>
                Voici la plaquette participant avec toutes les <a href="./././Plaquette_participants.pdf" download="Plaquette_participants.pdf" style={{ color: '#ffcc00', textDecoration: 'underline' }}>informations</a>.
              </Typography>

            </Box>
          </Fade>
        </Box>
        <Fade in={checked} container={containerRef.current} timeout={1300}>
          <Box sx={{ width: { xs: '90%', sm: 'auto' }, marginTop: { xs: '2rem', sm: 0 } }}>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2632.7537958985267!2d2.164267475952607!3d48.710186611125415!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47e67fea7f74431b%3A0x9f2fb6116f1bf79d!2sCentraleSup%C3%A9lec%20-%20B%C3%A2timent%20Eiffel%20-%20Universit%C3%A9%20Paris-Saclay!5e0!3m2!1sfr!2sfr!4v1721075988255!5m2!1sfr!2sfr"
              width="100%"
              height={isSmallScreen ? "300" : "450"}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              style={{ border: 'none', display: { xs: 'none', md: 'block' }}}
            ></iframe>
          </Box>
        </Fade>
      </Box>
    </Box>
  );
}

export default Infospratiques;
